import React, { Component } from "react";
import CardIntegratedPosition from "../CardIntegratedPosition/CardIntegratedPosition"

import bulletPoupancaImg from "../../images/side_bar/poupancas.svg";

// CSS
import "./BaseCardIntegratedPosition.css"

export class BaseCardIntegratedPosition extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingsIncome: this.props.incomeSavings,
            savingsGain: this.props.gainSavings,
            protectionCurrentAmount: this.props.protectionCurrentAmount,
            protectionsavingsCurrentAmount: this.props.protectionsavingsCurrentAmount
        };
    }

    constructorBase() {
        return (<div className="baseCardIntegratedPosition-gradient">
            <span className="baseCardIntegratedPosition-title">As minhas modalidades</span>
        </div>)
    }

    constructorSavingCard() {
        return (
            <CardIntegratedPosition
                icon={bulletPoupancaImg}
                title="POUPANÇA"
                value={new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.state.savingsIncome)}
                description="Aplicado em modalidades de Poupança"
                buttonText={this.state.savingsIncome > 0 ? "Ver detalhes" : "Subscrever"}
                onClick={() => this.props.history.push("/poupanca")}
            />
        )
    }

    constructorProtectionCard() {
        return (
            <CardIntegratedPosition
                icon={bulletPoupancaImg}
                title="PROTEÇÃO"
                value={new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(this.state.protectionCurrentAmount)}
                description="Capital Protegido"
                buttonText={this.state.protectionCurrentAmount > 0 ? "Ver detalhes" : "Subscrever"}
                onClick={() => this.props.history.push("/protecao")}
            />
        )
    }

    constructorProtectionSavingCard() {
        return (
            <CardIntegratedPosition
                icon={bulletPoupancaImg}
                title="PROTEÇÃO + POUPANÇA"
                value={new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(this.state.protectionsavingsCurrentAmount)}
                description="Capital Subscrito"
                buttonText={this.state.protectionsavingsCurrentAmount > 0 ? "Ver detalhes" : "Subscrever"}
                onClick={() => this.props.history.push("/protecao_poupanca")}
            />
        )
    }
    constructorCardsContainer() {
        return (<div className="baseCardIntegratedPosition-cardsContainer">
            {this.constructorSavingCard()}
            {this.constructorProtectionCard()}
            {this.constructorProtectionSavingCard()}
        </div>)
    }

    render() {
        let content = <div className="baseCardIntegratedPosition-container  base-container">
            {this.constructorBase()}
            {this.constructorCardsContainer()}
        </div>
        return <React.Fragment>{content}</React.Fragment>
    }
}